import { createUseStyles } from 'react-jss'

import { lightGrey } from '../../../../styles/const/colors'

export default createUseStyles({
  btnIcon: {
    // when hasBorder it inherits styles from the button component
    borderWidth: ({ hasBorder }) => (hasBorder ? null : 0),
    borderStyle: ({ hasBorder }) => (hasBorder ? null : 'none'),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px !important',
    '& .icon': {
      margin: 0,
      color: ({ color }) => (color ? color : lightGrey)
    }
  }
})
